<template>
  <div class="auth-wrap">
    <router-view/>
    <app-footer/>
  </div>
</template>

<script>
  import AppFooter from '../navigation/Footer'

  export default {
    components: {
      AppFooter
    },
    data () {
      return {
      }
    }
  }
</script>

<style lang="scss">
  @import 'auth';
</style>



// WEBPACK FOOTER //
// src/vue/auth/Auth.vue